export const LAUNCH_DARKLY_ANONYMOUS_EMAIL = 'anonymous@hqo.co';
export const BUILDING = 'BUILDING';
